
<template>
  <section v-html="content" v-once />
</template>

<script>
export default {
  created() {
    this.content = unescape(`%3Ch2%3EToast%3C/h2%3E%0A%3Cp%3E%u5F15%u5165%3C/p%3E%0A%3Cpre%3E%3Ccode%20class%3D%22language-js%22%3E%3Cspan%20class%3D%22hljs-keyword%22%3Eimport%3C/span%3E%20%7B%20Toast%20%7D%20%3Cspan%20class%3D%22hljs-keyword%22%3Efrom%3C/span%3E%20%3Cspan%20class%3D%22hljs-string%22%3E%27esc-ui%27%3C/span%3E%0A%0AVue.use%28Toast%29%0A%3C/code%3E%3C/pre%3E%0A%3Cp%3E%u4F7F%u7528%3C/p%3E%0A%3Cpre%3E%3Ccode%20class%3D%22language-js%22%3E%3Cspan%20class%3D%22hljs-keyword%22%3Ethis%3C/span%3E.%24escToast%28%3Cspan%20class%3D%22hljs-string%22%3E%27%u63D0%u793A%u8BED%27%3C/span%3E%29%0A%3Cspan%20class%3D%22hljs-comment%22%3E//%20%u6216%3C/span%3E%0AToast%28%3Cspan%20class%3D%22hljs-string%22%3E%27%u63D0%u793A%u8BED%27%3C/span%3E%29%0A%3C/code%3E%3C/pre%3E%0A`);
  }
};
</script>
